import ActivityTitle from "./ActivityTitle";

export default ActivityTitle;
